// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"312":"5aa377ea","454":"5aa377ea"}[chunkId] + ".chunk.css";
};